export default __webpack_public_path__ + "static/7-e0e6b1e0439d67739425bb10c07ab8b3.jpg";